import React, { useState } from 'react';
import PaymentRate2 from './PaymentRate.js';
import LoanCalculator from '../Home.js';


function PKOBP() {



  return (
    <div>ChangeLog
      <br></br>
      TODO
      <li>pekao sa - poprwa generowania ofert z CPI</li>
      <li>bezpieczny kredyt 2% - tylko oferty z ratami stałymi</li>
      <li>generowanie przez button popup z harmonogramem</li>
      <li>poprawa generowania tabeli z oferami</li>
      <li>wybór opcji cross-sell tak aby było generowanie na bieżąco</li>
      <li>przeniesienie bazdy danych</li>
      <li>zarządzanie bazą danych z panelu admina</li>
      <li>zaznaczanie konkretnej oferty i poprównanie z inną</li>
      <br></br>
      Test
      <s>
      <li>oferty Banków w bazie</li>
      <li>liczenie rat</li>
      <li>sortowanie po nazwie banku</li>
      <li>sortowanie po oprocentowaniu</li>
      <li>sortowanie po całkowitym koszcie</li>
      </s>
    </div>
  );     
}





export default PKOBP;